// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XWVX","importantInfo":"styles_importantInfo__q3q-t"};